
import styles from './QuickActionsCard.module.css';
import { BarChart2 } from 'lucide-react';
import { useEffect, useState } from 'react';
import { logsApi } from '../../../lib/apiClient';
import ReactECharts from 'echarts-for-react';

type DailyUsage = { date: string; count: number };

export default function QuickActionsCard() {
    const [dailyUsage, setDailyUsage] = useState<DailyUsage[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        async function fetchToolUsage() {
            setLoading(true);
            try {
                const response = await logsApi.getDailyToolUsage(200);
                const dailyArr = (response.dailyUsage || [])
                    .map((item: { date: string; count: number }) => ({ date: item.date, count: item.count }))
                    .sort((a: DailyUsage, b: DailyUsage) => a.date.localeCompare(b.date));
                setDailyUsage(dailyArr);
            } catch (e) {
                setDailyUsage([]);
            } finally {
                setLoading(false);
            }
        }
        fetchToolUsage();
    }, []);

    return (
        <div className={styles.card}>
            <h2 className={styles.cardTitle}><BarChart2 size={18} style={{ marginRight: 6, verticalAlign: 'middle' }} />Tools Usage</h2>
            {/* <div className={styles.buttonGroup}>
        {user && user?.role?.id < UserRole.Viewer && (
          <>
            <Link to="/toolslist/new" className={styles.iconButton}>
              <Plus size={16} />
              <span>Create New Tool</span>
            </Link>
            <Link to="/toolslist" className={styles.iconButtonSecondary}>
              <List size={16} />
              <span>Manage Tools</span>
            </Link>
          </>
        )}
      </div> */}
            <div>
                {/* <div className={styles.chartHeader}>Total Tool Usage Per Day</div> */}
                {loading ? (
                    <div className={styles.chartLoading}>Loading chart...</div>
                ) : dailyUsage.length === 0 ? (
                    <div className={styles.chartEmpty}>No tool usage data found.</div>
                ) : (
                    <ReactECharts
                        option={{
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: { type: 'cross' },
                            },
                            // legend: { data: ['Total Usage'] },
                            grid: { left: 40, right: 20, top: 40, bottom: 40 },
                            xAxis: {
                                type: 'category',
                                data: dailyUsage.map(d => d.date),
                                boundaryGap: false,
                                axisLabel: { fontSize: 12, rotate: 0 },
                            },
                            yAxis: {
                                type: 'value',
                                axisLabel: { fontSize: 12 },
                            },
                            series: [{
                                name: 'Total Usage',
                                type: 'line',
                                smooth: true,
                                data: dailyUsage.map(d => d.count),
                                showSymbol: false,
                                emphasis: { focus: 'series' },
                                lineStyle: { width: 4 },
                                itemStyle: { color: '#f9e77e' },
                            }],
                            animationDuration: 3000,
                            animationEasing: 'cubicOut',
                        }}
                        style={{ width: '100%', maxHeight: 320 }}
                        notMerge
                        lazyUpdate
                    />
                )}
            </div>
        </div>
    );
}
